export default data => {
  let id = 0;

  const features = data
    .map(feature => {
      id++;
      if (feature.gpsCoordinates) {
        const [lng, lat] = feature.gpsCoordinates.split(',').map(parseFloat);

        return {
          type: 'Feature',
          id,
          properties: {
            id,
            ...feature,
            icon: feature.assetClass ? feature.assetClass.toLowerCase().replace(' ', '-') : null,
          },
          geometry: {
            type: 'Point',
            coordinates: [lat, lng], // For MapBox, you have to supply the latitude and longitude in reversed order.
          },
        };
      }
    })
    .filter(val => val);

  return {
    id: 'places',
    type: 'symbol',
    source: {
      type: 'geojson',
      data: {
        type: 'FeatureCollection',
        features,
      },
    },
  };
};
